import Config from '../../utils/Config';

class ProjectLogo extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading : false,
            loaded  : false,
            uuid    : uuid()
        };

        this.onScroll = this.onScroll.bind(this);
    }

    componentDidMount() {
        $('.project').on('scroll', this.onScroll)

        this.onScroll();
    }

    onScroll() {
        var self = this;

        if (this.state.loading)
            return;


        var h           = $(window).height()
        var scrollTop   = $('.project').scrollTop()
        var offset      = $('#'+this.state.uuid).offset()
        var src         = Config.imgUrl()+'public/codi-studios/projects/'+this.props.id+'/'+this.props.project.img;

        if (offset.top < h + scrollTop + 400) {

            this.setState({ loading : true } , function() {

                var img = new window.Image();

                img.onload = function() {
                    var width   = this.width;
                    var height  = this.height;

                    self.setState({ loaded : true }, function() {
                        $('#img_'+self.state.uuid).css({ 'opacity' : 1 });
                    });
                }

                img.onerror = function() {
                    console.error('image missing :: '+src)
                }

                img.src = src;
            });
        }
    }

    render() {
        var project = this.props.project;
        var uuid    = this.state.uuid;

        return (
            <div
                className='project-logo section__head'
                id={uuid}>

                <h1>Logo Design<span>.</span></h1>

                <div className='section__h' />

                { this.state.loaded &&
                    <div className='project-logo__logo'>
                        <img
                            id={'img_'+uuid}
                            src={Config.imgUrl()+'/public/codi-studios/projects/'+this.props.id+'/'+project.img} />
                    </div>
                }

            </div>
        );
    }
}

export default ProjectLogo;




// WEBPACK FOOTER //
// ./ui_src/app/components/portfolio/ProjectLogo.react.jsx